<router-outlet />
<app-osint-background-poll-indicator />
@if (enableChatbot) {
  <app-help-bot-widget />
}
<div class="theme-selector-fixed">

    <!-- Sun Icon (Light Theme Activator) -->
    <button class="theme-icon-button" [class.active]="currentTheme === 'light-theme'" (click)="themeService.setTheme('light-theme')" title="Activate Light Theme">
        <i class="fas fa-sun"></i>
    </button>

    <!-- Moon Icon (Dark Theme Activator) -->
    <button class="theme-icon-button" [class.active]="currentTheme === 'dark-theme'" (click)="themeService.setTheme('dark-theme')" title="Activate Dark Theme">
        <i class="fas fa-moon"></i>
    </button>
</div>